import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/img/plan/paper_airplane.svg")